// 自定义事件名称
export const AGREEMENT_TRIGGER_EVENT = "show-agreement-confirmation";

/**
 * 触发协议确认弹框（用于登录/注册等场景）
 * @param onConfirm 确认后的回调
 * @param onCancel 取消后的回调
 */
export const triggerAgreementConfirmation = (
  onConfirm?: () => void,
  onCancel?: () => void
) => {
  window.dispatchEvent(
    new CustomEvent(AGREEMENT_TRIGGER_EVENT, {
      detail: { onConfirm, onCancel },
    })
  );
};
